<template>
  <MobileActionsSheet
    :open="open"
    label="Get the AudioScribe app"
    @close="dismiss"
  >
    <div class="app-install-sheet">
      <img src="/images/logo-dark.svg" alt="" />
      <h3>AudioScribe is better in the app</h3>
      <p>
        Record with your screen locked, get notified when transcripts are ready,
        and pick up right where you left off.
      </p>
      <a
        class="app-install-sheet__get"
        :href="storeUrl"
        target="_blank"
        rel="noopener"
        @click="onGet"
      >
        Get the app
      </a>
      <button type="button" class="app-install-sheet__web" @click="dismiss">
        Continue on web
      </button>
    </div>
  </MobileActionsSheet>
</template>

<script>
import MobileActionsSheet from "./MobileActionsSheet.vue";
import { getMobilePlatform, getStoreUrl } from "@/utils/platform";
import { shouldShowSheet, snoozeSheet } from "@/utils/app-promo";
import { analytics } from "@/services/analytics.service";

// Mirrors shouldShowSheet's returning-user rule (2nd+ session).
const SHEET_TRIGGER = "session_2";

export default {
  name: "AppInstallSheet",
  components: { MobileActionsSheet },
  data() {
    return {
      platform: getMobilePlatform(),
      open: false,
    };
  },
  computed: {
    storeUrl() {
      return getStoreUrl(this.platform);
    },
  },
  mounted() {
    // Returning users only (2nd+ boot), never on a first visit — see spec.
    if (this.storeUrl && shouldShowSheet()) {
      this.open = true;
      this.trackSheet(analytics.appInstallSheetShown);
    }
  },
  methods: {
    trackSheet(track) {
      track.call(analytics, {
        platform: this.platform,
        trigger: SHEET_TRIGGER,
      });
    },
    onGet() {
      this.trackSheet(analytics.appInstallSheetClicked);
      this.close();
    },
    dismiss() {
      this.trackSheet(analytics.appInstallSheetDismissed);
      this.close();
    },
    close() {
      snoozeSheet();
      this.open = false;
    },
  },
};
</script>
